import React from 'react'
import './Home.css'
import HomeItem from './HomeItem'
function Home() {
  return (
    <div className='body'>
        <div className="container" id="home">
        <p className="hi">
            Hi, I am Nejarul Islam
        </p>
        <h1>
            Professionally Computer Engineer
        </h1>
        <p className="para">Now-a-days from covid pendamic situation website is our essential component for business growing
            .Every Businessman need website for their business for online marketing and online sell
            .Simply You can hire me for your own business website design.
        </p>
    </div>
    <div className="container d-flex justify-content-between" id="about">
        <div className="row">
            <div className="item"> 
                <HomeItem about="Importance of web and app devlopment" body="If you need to reach a wider audience and want to offer a more cost-effective solution, web development may be the way to go. On the other hand, if you need a more personalized user experience, and want to take advantage of platform-specific features, app development may be the better choice." img="https://www.nicepng.com/png/detail/252-2527662_what-is-the-importance-of-web-application-development.png"/>
            </div>
            <div className="item">
            <HomeItem about="Without web and app solution" body="Without web and app solutions, businesses would struggle to reach customers, resulting in limited visibility and reduced accessibility. Transactions would become slower and less efficient, and competitors with digital tools could gain a significant advantage. Additionally, the absence of web and app platforms would hinder data insights, customer engagement, and overall operational efficiency." img="https://images.squarespace-cdn.com/content/v1/5b17865575f9ee4ef2fc3753/1538979941901-S6HVC4CIXCMW1AAB05BV/0.jpg?format=1000w"/>
            </div>
            <div className=" item">
            <HomeItem about=" Business crisis without web and app technologies" body="
            A small example of a business crisis without web and app technologies could be a manufacturing company facing a sudden equipment breakdown that disrupts production. Without web and app solutions, communicating with suppliers, customers, and employees to coordinate repairs, reschedule orders, and provide updates would be slower and less efficient, potentially leading to delays, customer dissatisfaction, and financial losses. The absence of digital tools could hinder the company's ability to quickly address and mitigate the crisis" img="https://resources.mojomedialabs.com/hubfs/SW_mojo-blog-header-3%20Great%20Examples%20of%20Crisis%20Management%20on%20Social%20Media.jpg"/>
            </div>
          </div>
        </div>
    </div>
   
  )
}

export default Home
